import React from 'react';
import globalsService from '../../services/GlobalsService';
import { t } from '../../services/i18nService';
import styles from './App.scss';

class CatTriggerInProgress extends React.PureComponent {
    render() {
        const assetRoot = globalsService.getAssetRoot();
        const src = `${!assetRoot ? '' : `${assetRoot}/`}images/loading-spinner.svg`;
        return (
            <div className={`${styles.catInProgressComponent} ${styles.centered}`}>
                <svg aria-hidden="true">
                    <image href={src} height="100%" width="100%" />
                </svg>
                <div className={styles.info}>
                    {t('catInProgress.message')}
                </div>
            </div>
        );
    }
}

export default CatTriggerInProgress;
